import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactStars from 'react-rating-stars-component';
import CustomerReviewModal from '@/components/CustomerReviewModal';
import styles from './ItemWithReview.module.scss';
import { deviceWidth } from '@/utils/deviceWidth';
import { useFeatureLocks } from '@/hooks/useFeatureLocks';
import router from 'next/router';
import { getRoute } from 'src/utils/routes';
import { getProductPathFromUrl } from 'src/utils/productUtils';
import { IS_SERVER } from 'src/utils/checkRenderEnv';

const ItemWithReview = ({ order, item, isComplete }) => {
  const loggedInUserReview =
    Array.isArray(item?.store_item_review_rating?.review_rating) &&
    item?.store_item_review_rating?.review_rating[0];
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [rating, setRating] = useState(
    loggedInUserReview ? loggedInUserReview?.rating : 0
  );
  const { storeInfo, reviewSettings } = useSelector((state) => ({
    storeInfo: state.storeReducer.store,
    reviewSettings: state.catalogReducer.reviewSettings,
  }));

  const { crrFeatureStatus } = useFeatureLocks();
  const isCRRFeatureUnlocked = !crrFeatureStatus?.isLocked;

  useEffect(() => {
    if (loggedInUserReview) setRating(loggedInUserReview?.rating);
  }, [loggedInUserReview]);

  const handleReviewModalOpen = () => setOpenReviewModal(true);

  const handleReviewModalClose = () => {
    setOpenReviewModal(false);
    setRating(loggedInUserReview?.rating);
  };

  const handleStopPropagation = (e) => e.stopPropagation();

  return (
    <>
      <div className={styles.reviewItemContainer}>
        <div
          className="tw-flex  tw-items-center tw-gap-[16px]"
          onClick={(e) => {
            e.stopPropagation();
            router.push(
              getRoute(
                getProductPathFromUrl(item?.link, false),
                storeInfo?.store_info?.domain
              )
            );
          }}
        >
          <img src={item.thumbnail_url} width="64px" height="64px" />
          <p className="mv0 f14px">
            {item.item_name} X {item.quantity}
          </p>
        </div>
        <div className="flex flex-column pv10px pl16px">
          <div></div>
          {isComplete &&
          reviewSettings?.status &&
          isCRRFeatureUnlocked &&
          deviceWidth > 766 ? (
            <div className="flex items-center pt10px">
              <p className="mv0 star-dust f12px">
                {loggedInUserReview?.rating ? 'Your rating' : 'Rate product'}
              </p>
              <div className="pl8px flex items-center" onClick={handleStopPropagation}>
                <span
                  className="tw-flex tw-cursor-pointer"
                  onClick={handleReviewModalOpen}
                >
                  <ReactStars
                    key={`stars_${rating}`}
                    size={21}
                    classNames={styles.gap}
                    onChange={(rating) => {
                      setRating(rating);
                      handleReviewModalOpen();
                    }}
                    value={rating}
                    count={5}
                  />
                </span>
                <div className={styles.verticalLine} />
                <p className={styles.writeReview} onClick={handleReviewModalOpen}>
                  {loggedInUserReview?.review ? 'Edit review' : 'Write a Review'}
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {isComplete &&
      reviewSettings?.status &&
      isCRRFeatureUnlocked &&
      deviceWidth <= 766 ? (
        <div className="flex flex-column items-start pt10px">
          <div className="flex items-center" onClick={handleStopPropagation}>
            <p className="mv0 star-dust">
              {loggedInUserReview?.rating ? 'Your rating' : 'Rate product'}
            </p>
            <div className="pl8px">
              <ReactStars
                key={`stars_${rating}`}
                size={21}
                classNames={styles.gap}
                onChange={(rating) => {
                  setRating(rating);
                  handleReviewModalOpen();
                }}
                value={rating}
                count={5}
              />
            </div>
          </div>
          {deviceWidth > 766 ? (
            <div className={styles.verticalLine} onClick={handleStopPropagation} />
          ) : null}
          <div className="mt16px mb8px" onClick={handleStopPropagation}>
            <p className={styles.writeReview} onClick={handleReviewModalOpen}>
              {loggedInUserReview?.review ? 'Edit review' : 'Write a Review'}
            </p>
          </div>
        </div>
      ) : null}
      <div onClick={handleStopPropagation}>
        <CustomerReviewModal
          ratingFromProps={rating}
          open={openReviewModal}
          onClose={handleReviewModalClose}
          product={item}
          order_id={order.order_id}
          loggedInUserReview={loggedInUserReview}
          onSubmit={() => !IS_SERVER && window.location.reload()}
        />
      </div>
    </>
  );
};

export default ItemWithReview;
